<app-message-install-pwa></app-message-install-pwa>

<router-outlet />
